"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var filterRelevantQueryContextEntries = function (queryContext, relevantKeys) {
    var keyValues = new Map();
    queryContext.getContextEntries().forEach(function (value, contextualParameter) {
        if (relevantKeys.includes(contextualParameter)) {
            keyValues.set(contextualParameter, value);
        }
    });
    return keyValues;
};
// These methods will read the configuration from disk/memory.
var OfflineConfigStore = /** @class */ (function () {
    function OfflineConfigStore(featureStorage, contextualParameterNames, weblabRulesResolver) {
        this.featureStorage = featureStorage;
        this.contextualParameterNames = contextualParameterNames;
        this.weblabRulesResolver = weblabRulesResolver;
    }
    OfflineConfigStore.prototype.executeQuery = function (configKey, queryContext, weblabContext) {
        var relevantContextualParameters = filterRelevantQueryContextEntries(queryContext, this.contextualParameterNames);
        var featureRecord = this.featureStorage.getRecord({
            contextualParameters: relevantContextualParameters,
            attributeName: configKey,
        });
        if (!featureRecord) {
            return null;
        }
        return this.weblabRulesResolver.resolve(featureRecord.attributeValue, weblabContext, featureRecord.weblabRules);
    };
    OfflineConfigStore.prototype.getValue = function (key, context, weblabContext) {
        return this.executeQuery(key, context, weblabContext);
    };
    return OfflineConfigStore;
}());
exports.default = OfflineConfigStore;
